import React from 'react';
import { RedocStandalone } from 'redoc';

import playapiInDocs from './playapiInDocs.json';

function PlayapiV1Docs() {
    return (
        <div>
            <RedocStandalone spec={playapiInDocs} />
        </div>
    );
}

export default PlayapiV1Docs;
